import { render, staticRenderFns } from "./goods-level.vue?vue&type=template&id=23929dc2&scoped=true"
import script from "./goods-level.vue?vue&type=script&lang=js"
export * from "./goods-level.vue?vue&type=script&lang=js"
import style0 from "./goods-level.vue?vue&type=style&index=0&id=23929dc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b5e12a4b1c1729405afdf532a227c02e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23929dc2",
  null
  
)

export default component.exports